import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromLandingPages from '../reducers/landing-pages.reducer';
import { LandingPage } from '../../models';
import * as fromRoot from '../../../store';

export const getLandingPageState = createSelector(fromFeature.getLandingState, (state: fromFeature.LandingState) => state.landingPages);

export const getLandingPageEntities = createSelector(getLandingPageState, fromLandingPages.getLandingPagesEntities);

export const getAllLandingPages = createSelector(getLandingPageEntities, entities => {
  return Object.keys(entities).map(slug => entities[slug]);
});

export const getLandingPagesLoaded = createSelector(getLandingPageState, fromLandingPages.getLandingPagesLoaded);
export const getLandingPagesLoading = createSelector(getLandingPageState, fromLandingPages.getLandingPagesLoading);

export const getSelectedLandingPage = createSelector(getLandingPageEntities, fromRoot.getRouterState, (entities, router): LandingPage => {
  return router.state && entities[router.state.params?.['slug'] || router.state.data?.['slug']];
});

export const getSelectedLandingPageLoading = createSelector(getLandingPagesLoading, fromRoot.getRouterState, (slugs, router): boolean => {
  return router.state && slugs.includes(router.state.params?.['slug'] || router.state.data?.['slug']);
});

export const getSelectedLandingPageLoaded = createSelector(getLandingPagesLoaded, fromRoot.getRouterState, (slugs, router): boolean => {
  return router.state && slugs.includes(router.state.params?.['slug'] || router.state.data?.['slug']);
});
